import { CHANGE_EVENT, isFavourite, toggleFavourite } from '@theme/favourites-store';

// Wraps a heart button; reads data-handle and swaps labels from data-* strings written by Liquid.
class SFavouriteButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const button = this.querySelector('button');
    if (!button || !this.dataset.handle) return;

    this.#render();

    button.addEventListener('click', () => {
      const added = toggleFavourite(this.dataset.handle);
      const message = added ? this.dataset.savedMessage : this.dataset.removedMessage;
      if (message) {
        document.dispatchEvent(new CustomEvent('s-notification:add', {
          detail: { message, duration: 4000 },
        }));
      }
    }, opts);

    document.addEventListener(CHANGE_EVENT, () => this.#render(), opts);
    window.addEventListener('storage', () => this.#render(), opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #render() {
    const button = this.querySelector('button');
    const label = this.querySelector('[data-favourite-label]');
    const saved = isFavourite(this.dataset.handle);
    button.setAttribute('aria-pressed', String(saved));
    if (label) label.textContent = saved ? this.dataset.labelSaved : this.dataset.labelSave;
  }
}

if (!customElements.get('s-favourite-button')) {
  customElements.define('s-favourite-button', SFavouriteButton);
}
